<app-toolbar></app-toolbar>
<div class="body-estruct" loader [switch]="switchLoader">
    <div class="container py-20x">
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <div id="btn_regresar_cotizacion" class="btn-back" (click)="back()">< Regresar</div>
                    </div>
                </div>
                <div class="row justify-content-md-center">
                    <div class="col-md-6 text-center">
                        <div class="table-sio m-auto">
                            <div class="cell-sio">
                                <div class="icon-paso-num">1</div>
                                <div class="lbl-paso">Datos Personales</div>
                                <div class="lbl-separate-disabled">></div>
                                <div class="icon-paso-num-disabled">2</div>
                                <div class="lbl-paso-disabled d-none d-lg-block">Datos del Vehículo</div>
                                <div class="lbl-separate-disabled">></div>
                                <div class="icon-paso-num-disabled">3</div>
                                <div class="lbl-paso-disabled d-none d-lg-block">Datos de Pago</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="lbl-subtitle">Por favor llena los siguientes datos.</div>
                    </div>
                </div>
            </div>
              <div class="col-12 align-self-center">

                <form #form="ngForm" id="form2" name="form-emision">
                <div class="col-12">
                    <div class="row">
                        <div class="col align-self-center">
                            <div class="tarjeta-form">
                                    <h3 class="lbl-titulo">Datos Personales</h3>
                                    <div class="row">
                                        <div class="w-100">
                                            <label class="lb-form">Nombres(s)<span class="red">*</span></label>
                                            <input name="nombre" id="txNombre" type="text" placeholder="" autocomplete="off" [(ngModel)]="contratante.nombres" maxlength="20" (keypress)="limiteLetras($event)">
                                        </div>
                                        <div class="w-100">
                                            <label class="lb-form">Apellido Paterno<span class="red">*</span></label>
                                            <input name="apPat" id="txApPat" type="text" placeholder="" autocomplete="off" [(ngModel)]="contratante.ap_pat" maxlength="20" (keypress)="limiteLetras($event)">
                                        </div>
                                        <ng-container *ngIf="(aseguradoraId == 29 || aseguradoraId == 49 || aseguradoraId == 1) else noRequired">
                                            <div class="w-100">
                                                <label class="lb-form">Apellido Materno<span class="red">*</span></label>
                                                <input name="apMat1" id="txApMat1" type="text" placeholder="" autocomplete="off" [(ngModel)]="contratante.ap_mat" maxlength="20" (keypress)="limiteLetras($event)">
                                            </div>
                                        </ng-container>
                                        <ng-template #noRequired>
                                            <div class="w-100">
                                                <label class="lb-form">Apellido Materno</label>
                                                <input name="apMat2" id="txApMat2" type="text" placeholder="" autocomplete="off" [(ngModel)]="contratante.ap_mat" maxlength="20" (keypress)="limiteLetras($event)">
                                            </div>
                                        </ng-template>
                                        <div class="w-ssm-100 w-sm-100 w-md-50">
                                            <label class="lb-form">Fecha de Nacimiento (dd/mm/aaaa)<span class="red">*</span></label>
                                            <input name="birthDate" id="txbirth" type="text" matInput [imask]="fecNacimientoMask" placeholder="dd/mm/aaaa" (blur)="generaRFC()" [(ngModel)]="contratante.fec_nac">
                                        </div>
                                        <div class="w-5 d-none d-md-block"></div>
                                        <div class="w-ssm-100 w-sm-100 w-md-45">
                                            <label class="lb-form">Sexo<span class="red">*</span></label>
                                            <select name="sexo" id="slctSexo" type="text" placeholder="Sexo" [(ngModel)]="contratante.sexo" (ngModelChange)="sexoEventListener($event)">
                                                <option value="">Sexo</option>
                                                <option value="M">Hombre</option>
                                                <option value="F">Mujer</option>
                                            </select>
                                        </div>
                                        <div class="w-100">
                                            <label class="lb-form">RFC<span class="red">*</span></label>
                                            <input name="rfc" id="txRFC" type="text" placeholder="" autocomplete="off" (focus)="generaRFC()" [(ngModel)]="contratante.rfc" maxlength="13">
                                        </div>
                                        <div class="w-50">
                                            <label class="lb-form">Celular<span class="red">*</span></label>
                                            <input name="celular" id="txCelular" type="text" placeholder="" autocomplete="off" [(ngModel)]="celular" [imask]="telefonoMask">
                                        </div>
                                        <div class="w-5"></div>
                                        <div class="w-45">
                                            <label class="lb-form">Teléfono</label>
                                            <input name="telefono" id="txTelefono" type="text" placeholder="" autocomplete="off" [(ngModel)]="telefono" [imask]="telefonoMask">
                                        </div>
                                        <h3 class="lbl-titulo">Domicilio</h3>
                                        <!-- <div class="w-100">
                                            <input type="text" placeholder="Conductor" autocomplete="off" [(ngModel)]="conductor.nombres">
                                        </div> -->
                                        <div class="w-100">
                                            <label class="lb-form">Calle<span class="red">*</span></label>
                                            <input name="calle" id="txCalle" type="text" placeholder="" autocomplete="off" [(ngModel)]="contratante.direccion.calle" maxlength="40" (keypress)="limitLetrasNumeros($event)">
                                        </div>
                                        <div class="w-50">
                                            <label class="lb-form">Número Externo<span class="red">*</span></label>
                                            <div class="d-flex justify-content-end align-items-center">
                                                <mat-icon style="position: absolute;" class="icoInfo" #tooltip="matTooltip" matTooltipClass="tool-tip" 
                                                matTooltip=" Ayúdanos a ajustar tus datos a 10 caracteres." matTooltipPosition='right'>info</mat-icon>
                                                <input name="noExterno" id="txNoExterno" type="text" placeholder="" autocomplete="off" [(ngModel)]="contratante.direccion.no_ext" maxlength="10" (keypress)="limitLetrasNumeros($event)">
                                            </div>
                                        </div>
                                        <div class="w-5"></div>
                                        <div class="w-45">
                                            <label class="lb-form">Número Interno</label>
                                            <div class="d-flex justify-content-end align-items-center">
                                                <mat-icon style="position: absolute;" class="icoInfo" #tooltip="matTooltip"
                                                matTooltipClass="tool-tip" 
                                                matTooltip=" Ayúdanos a ajustar tus datos a 10 caracteres." matTooltipPosition='right'>info</mat-icon>
                                                <input name="noInterno" id="txNoInterno" type="text" placeholder="" autocomplete="off" [(ngModel)]="contratante.direccion.no_int" maxlength="10" (keypress)="limitLetrasNumeros($event)">
                                            </div>
                                        </div>
                                        <div class="w-100">
                                            <label class="lb-form">Código Postal<span class="red">*</span></label>
                                            <input name="codPos" id="txCP" type="text" (keypress)="numericOnly($event)" maxlength="5" placeholder="" autocomplete="off" (keyup)="getCodigoPostal()" [(ngModel)]="contratante.direccion.cp"
                                            [disabled]="contratante.direccion.cp != ''">
                                        </div>
                                        <div class="w-100">
                                            <!-- <input type="text" placeholder="Colonia" autocomplete="off" [(ngModel)]="contratante.direccion.col"> -->
                                            <label class="lb-form">Colonia<span class="red">*</span></label>
                                            <select name="colonia" id="slctColonia" type="text" placeholder="" [(ngModel)]="contratante.direccion.col">
                                                <option *ngFor="let colonia of arrayColonia" [value]="colonia.c2">{{colonia.c2}}</option>
                                            </select>
                                        </div>
                                        <div class="w-100">
                                            <!-- <select disabled type="text" placeholder="Ciudad" [(ngModel)]="contratante.direccion.ciudad">
                                                <option *ngFor="let ciudad of arrayCiudad" [value]="ciudad.c2">{{ciudad.c2}}</option>
                                            </select> -->
                                            <label class="lb-form">Ciudad<span class="red">*</span></label>
                                            <input disabled name="ciudad" id="txCiudad" type="text" placeholder="" autocomplete="off" [(ngModel)]="contratante.direccion.ciudad">
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 offset-md-3">
                    <button id="btn_dp_continuar" name="continuar" id="btnContinuar" mat-flat-button class="w-100" [color]="styleCocheSeguro?.colorBtn" (click)="next()"
                    [disabled]="(
                        (contratante.nombres==='' || contratante.ap_pat==='' || contratante.fec_nac==='' || contratante.rfc==='') ||
                        (contratante.direccion.calle==='' || contratante.direccion.no_ext==='' || contratante.direccion.cp==='') || (celular === '') ||
                        ((aseguradoraId == 1 || aseguradoraId == 29 || aseguradoraId == 49) && contratante.ap_mat == '')
                    )">CONTINUAR</button>
                </div>
                </form>
              </div>  


            <!-- <div class="row">
                <div class="col-12 py-20x">
                    <button mat-flat-button class="btn-ayuda font-ayuda" (click)="obtenerAyuda()">
                        <mat-icon>phone</mat-icon> Ayuda
                    </button>
                </div>
            </div> -->
            <button id="btn_dp_ayuda" mat-flat-button class="btn-ayuda font-ayuda ocultar-btn" (click)="updateJson()">
                <mat-icon>phone</mat-icon> Ayuda
            </button>
        </div>
    </div>
</div>
<app-footer></app-footer>